import React from 'react'
import { IconButton } from 'view/components/buttons'
import * as constants from 'view/styles/constants'
import { Tooltip } from 'view/components/tooltip'
import { Locale, Translation } from 'locale'
import styled from '@emotion/styled'

interface ToolbarButtonProps {
  tooltip: Translation
  className?: string
  onClick: () => unknown
  dataTestId?: string
  children?: React.ReactNode
}

const ToolbarButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: white;
  width: 32px;
  height: 26px;
  &:hover ${IconButton} {
    color: ${constants.ACCENT_PRIMARY};
  }
`

export const ToolbarButton: React.FunctionComponent<ToolbarButtonProps> = props => {
  const { tooltip, onClick, children, dataTestId, className } = props
  return (
    <Tooltip tooltip={Locale.translate(tooltip)}>
      <ToolbarButtonWrapper className={className}>
        <IconButton onClick={onClick} dataTestId={dataTestId}>
          {children}
        </IconButton>
      </ToolbarButtonWrapper>
    </Tooltip>
  )
}
